/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/**
 * Imprt CSS.
 */
import "swiper/css/bundle";

// YouTube IframeAPI の読み込み
let tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
let firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// プレイヤーを保持するオブジェクト
let players = {};

/**
 * 共通スライダー
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const defaultSlider = () => {
	// 印刷時はスライダーを初期化しない
	if (window.matchMedia("print").matches) {
		return;
	}

	let sliderInstance = null;

	const option = {
		loop: true,
		speed: 1000,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
		// },
		navigation: {
			nextEl: ".slider-arrow-next",
			prevEl: ".slider-arrow-prev",
		},
		pagination: {
			el: ".slider-default-pagination",
			clickable: true,
		},
	};

	sliderInstance = new Swiper(".slider-default", option);

	// 印刷前にスライダーを破棄
	window.addEventListener("beforeprint", () => {
		if (sliderInstance) {
			sliderInstance.destroy(true, true);
			sliderInstance = null;
		}
	});

	// 印刷後にスライダーを再初期化
	window.addEventListener("afterprint", () => {
		if (!sliderInstance) {
			sliderInstance = new Swiper(".slider-default", option);
		}
	});
};

const mvSlider = () => {
	// if (window.matchMedia("(min-width: 600px)").matches) {
	// 	var centeredSlides = "false";
	// } else {
	// 	var centeredSlides = "ture";
	// }

	/**
	 * Setting - Thumbnail Slider - デフォルト
	 */
	const optionThumbnail = {
		loop: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		speed: 2000,
	};
	const sliderThumbnail = new Swiper(".slider-mv-parse", optionThumbnail);

	const option = {
		loop: true,
		parallax: true,
		speed: 2000,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
		},
		thumbs: {
			swiper: sliderThumbnail,
		},
	};

	const slider = new Swiper(".slider-mv", option);
};

const fadeSlider = () => {
	/**
	 * Setting - Fade Slider - デフォルト
	 */
	const option = {
		loop: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		speed: 2000,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
		},
	};

	/**
	 * Action - Fade Slider - デフォルト
	 */
	const slider = new Swiper(".slider-fade", option);
};

const thumbnailSlider = () => {
	const body = window.document.body;
	const classList = body.classList;

	if ([...classList].some((className) => className.startsWith("share-"))) {
		/**
		 * Setting - Thumbnail Slider
		 */
		const optionThumbail = {
			slidesPerView: 4,
			spaceBetween: 10,
			grabCursor: true,
			breakpoints: {
				761: {
					slidesPerView: 9,
					spaceBetween: 20,
				},
			},
		};

		const sliderThumbnail = new Swiper(".slider__thumbnail", optionThumbail);

		/**
		 * Setting - Main Slider
		 */
		const optionMain = {
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			speed: 1000,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			// navigation: {
			// 	nextEl: ".swiper-button-next",
			// 	prevEl: ".swiper-button-prev",
			// },
			thumbs: {
				swiper: sliderThumbnail,
			},
		};

		const sliderThumbnailMain = new Swiper(".slider__thumbnail__main", optionMain);
	}
};

const carouselSlider = () => {
	/**
	 * Setting - Carousel Slider - デフォルト
	 */
	const option = {
		slidesPerView: 2,
		spaceBetween: 5,
		centeredSlides: true,
		loop: true,
		speed: 1500,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
			// disableOnInteraction: false,
		},
		breakpoints: {
			// スライドの表示枚数：500px以上の場合
			640: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			760: {
				slidesPerView: 4,
				spaceBetween: 10,
			},
			1441: {
				slidesPerView: 6,
				spaceBetween: 10,
			},
		},
		// pagination: {
		// 	el: ".swiper-pagination",
		// 	clickable: true,
		// },
	};

	/**
	 * Action - Carousel Slider - デフォルト
	 */
	const sliderCarousel = new Swiper(".slider-carousel", option);
};

const postSlider = () => {
	// 印刷時はスライダーを初期化しない
	if (window.matchMedia("print").matches) {
		return;
	}

	let sliderInstance = null;

	/**
	 * Setting - post Slider - デフォルト
	 */
	const option = {
		slidesPerView: 2,
		spaceBetween: 15,
		loop: true,
		speed: 1000,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		breakpoints: {
			960: {
				slidesPerView: 3,
				spaceBetween: 60,
			},
			760: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	};

	/**
	 * Action - post Slider - デフォルト
	 */
	sliderInstance = new Swiper(".slider-post", option);

	// 印刷前にスライダーを破棄
	window.addEventListener("beforeprint", () => {
		if (sliderInstance) {
			sliderInstance.destroy(true, true);
			sliderInstance = null;
		}
	});

	// 印刷後にスライダーを再初期化
	window.addEventListener("afterprint", () => {
		if (!sliderInstance) {
			sliderInstance = new Swiper(".slider-post", option);
		}
	});
};

const conceptThumbnailSlider = () => {
	/**
	 * Setting - Thumbnail Slider
	 */
	const optionThumbail = {
		slidesPerView: 4,
		spaceBetween: 10,
		grabCursor: true,
		breakpoints: {
			761: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
		},
	};

	const thumbnailElements = document.querySelectorAll(".slider__thumbnail");
	const mainElements = document.querySelectorAll(".slider__thumbnail__concept");

	thumbnailElements.forEach((el, index) => {
		const thumbnailSlider = new Swiper(el, optionThumbail);

		/**
		 * Setting - Main Slider
		 */
		const optionMain = {
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			speed: 1000,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: el.parentElement.querySelector(".slider-arrow-next"),
				prevEl: el.parentElement.querySelector(".slider-arrow-prev"),
			},
			thumbs: {
				swiper: thumbnailSlider,
			},
		};

		if (mainElements[index]) {
			new Swiper(mainElements[index], optionMain);
		}
	});
};

// モーダルの制御
function setupModalControls() {
	const slides = document.querySelectorAll(".movie-slide");

	slides.forEach((slide) => {
		const dialog = slide.querySelector(".movie-modal");
		const showButton = slide.querySelector(".link");
		const closeButton = slide.querySelector(".close-modal");

		if (!dialog || !showButton || !closeButton) return;

		showButton.addEventListener("click", (e) => {
			e.preventDefault();
			dialog.showModal();
			initializeVideo(slide);
		});

		closeButton.addEventListener("click", (e) => {
			e.preventDefault();
			stopVideo(slide);
			dialog.close();
		});

		dialog.addEventListener("close", () => {
			stopVideo(slide);
		});
	});
}

// 動画の初期化
function initializeVideo(slide) {
	const container = slide.querySelector(".youtube-container");
	if (!container) return;

	const youtubeId = container.dataset.youtubeId;
	if (!youtubeId) return;

	if (players[youtubeId]) {
		players[youtubeId].destroy();
	}

	container.innerHTML = "";

	const iframe = document.createElement("iframe");
	iframe.width = "438";
	iframe.height = "778";
	iframe.src = `https://www.youtube.com/embed/${youtubeId}?enablejsapi=1&autoplay=1&mute=1&loop=1&playlist=${youtubeId}&playsinline=1&origin=${window.location.origin}`;
	iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
	iframe.allowFullscreen = true;
	container.appendChild(iframe);

	players[youtubeId] = new YT.Player(iframe, {
		events: {
			onReady: (event) => {
				event.target.playVideo();
				const swiperInstance = slide.closest(".swiper-container").swiper;
				if (swiperInstance) {
					swiperInstance.autoplay.stop();
				}
			},
			onStateChange: (event) => {
				const swiperInstance = slide.closest(".swiper-container").swiper;
				if (event.data === YT.PlayerState.ENDED && swiperInstance) {
					swiperInstance.autoplay.start();
				}
			},
			onError: (event) => {
				console.error("YouTube Player Error:", event.data);
				const swiperInstance = slide.closest(".swiper-container").swiper;
				if (swiperInstance) {
					swiperInstance.autoplay.start();
				}
			},
		},
	});
}

// 動画の停止
function stopVideo(slide) {
	const container = slide.querySelector(".youtube-container");
	if (!container) return;

	const youtubeId = container.dataset.youtubeId;
	if (!youtubeId || !players[youtubeId]) return;

	players[youtubeId].stopVideo();

	const swiperInstance = slide.closest(".swiper-container").swiper;
	if (swiperInstance) {
		swiperInstance.autoplay.start();
	}
}

const movieSlider = () => {
	// スライドの複製を事前に行う
	const originalSlides = document.querySelectorAll(".movie-slider .swiper-slide");
	const wrapper = document.querySelector(".movie-slider .swiper-wrapper");

	if (originalSlides.length && wrapper) {
		// 必要な複製数を計算（最低でも10枚になるように）
		const requiredCopies = Math.max(2, Math.ceil(10 / originalSlides.length));

		// スライドを複製
		for (let i = 0; i < requiredCopies; i++) {
			originalSlides.forEach((slide) => {
				const clone = slide.cloneNode(true);
				clone.classList.add("swiper-slide-duplicate");
				wrapper.appendChild(clone);
			});
		}

		// Swiperの初期化
		const movieSwiper = new Swiper(".movie-slider", {
			slidesPerView: 1.5,
			spaceBetween: 5,
			centeredSlides: true,
			loop: true,
			loopedSlides: originalSlides.length,
			speed: 1500,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
				disableOnInteraction: false,
			},
			breakpoints: {
				640: {
					slidesPerView: 3,
					spaceBetween: 10,
				},
				760: {
					slidesPerView: 4,
					spaceBetween: 10,
				},
				1441: {
					slidesPerView: 6,
					spaceBetween: 10,
				},
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			on: {
				init: function () {
					setTimeout(() => {
						this.update();
					}, 0);
				},
				slideChange: function () {
					document.querySelectorAll(".movie-slide").forEach((slide) => {
						slide.classList.remove("current");
					});
					const activeSlide = this.slides[this.activeIndex];
					if (activeSlide) {
						activeSlide.classList.add("current");
					}
				},
			},
		});

		// モーダル制御のイベントを複製したスライドにも適用
		setupModalControls();

		// ホバー時の一時停止
		const sliderEl = document.querySelector(".movie-slider");
		if (sliderEl) {
			sliderEl.addEventListener("mouseenter", () => {
				movieSwiper.autoplay.stop();
			});

			sliderEl.addEventListener("mouseleave", () => {
				movieSwiper.autoplay.start();
			});
		}
	}
};

// YouTube APIの読み込み完了時の処理
window.onYouTubeIframeAPIReady = function () {
	const movieSliderElement = document.querySelector(".movie-slider");
	if (movieSliderElement) {
		setupModalControls();
	}
};

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/*index: set */

const setSlider = () => {
	defaultSlider();
	mvSlider();
	fadeSlider();
	thumbnailSlider();
	carouselSlider();
	postSlider();
	conceptThumbnailSlider();
	movieSlider(); // ムービースライダーを追加
};
export { setSlider };
